export default __webpack_public_path__ + "static/media/privacy.d6db81af.svg";